import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

const ResultPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { name, age, birthDate, qrData, text } = location.state || {};
  const [response, setResponse] = useState("");
  const [quizResponse, setQuizResponse] = useState("");
  const [loading, setLoading] = useState(true);
  const [quizLoading, setQuizLoading] = useState(false);
  const [quizLoaded, setQuizLoaded] = useState(false);
  const [parsedQuiz, setParsedQuiz] = useState([]);
  const [selectedAnswers, setSelectedAnswers] = useState({});

  useEffect(() => {
    if (!name || !age || !birthDate || !text) {
      navigate("/");
      return;
    }

    const fetchData = async () => {
      try {
        const API_KEY = "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"; // Replace with your OpenAI API key
        const url = "https://api.openai.com/v1/chat/completions"; // OpenAI API endpoint
    
        const requestData = {
          model: "gpt-4o-mini", // Use "gpt-4-turbo" or "gpt-3.5-turbo"
          messages: [
            { role: "system", content: "You are a professional teacher" },
            { role: "user", content: text }, // No need for template literals
          ],
          stream: false,
        };
    
        const headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${API_KEY}`,
        };
    
        const res = await axios.post(url, requestData, { headers });
        const message = res.data.choices[0].message.content;
    
        const formattedText = formatText(message);
        setResponse(formattedText);
        speakText(formattedText); // 🔊 Speak API response
      } catch (error) {
        console.error("OpenAI API error:", error);
        setResponse("Failed to get a response. Please try again.");
      } finally {
        setLoading(false);
      }
    };
    

    fetchData();
  }, [name, age, birthDate, qrData, navigate]);

  // Function to format text for display
  const formatText = (text) => {
    return text
      .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>") // Bold
      .replace(/\*(.*?)\*/g, "<em>$1</em>") // Italics
      .replace(/🐯|🐾|😄|✋|🍿/g, ""); // Remove emojis for speech
  };

  // Function to handle text-to-speech
  const speakText = (text) => {
    if ("speechSynthesis" in window) {
      const cleanText = text.replace(/[*_]/g, ""); // Remove markdown symbols for speech
      const speech = new SpeechSynthesisUtterance(cleanText);
      speech.lang = "en-US";
      speech.rate = 1;
      speech.pitch = 1;
      window.speechSynthesis.speak(speech);
    } else {
      alert("Text-to-Speech is not supported in your browser.");
    }
  };

  // Function to fetch a quiz related to the QR data
  const fetchQuiz = async () => {
    setQuizLoading(true);
    try {
      const API_KEY = "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"; // Replace with your OpenAI API key
      const url = "https://api.openai.com/v1/chat/completions"; // OpenAI API endpoint
  
      const requestData = {
        model: "gpt-4o-mini", // Use "gpt-4-turbo" or "gpt-3.5-turbo"
        messages: [
          { role: "system", content: "You are a professional quiz generator." },
          {
            role: "user",
            content: `Create 5 fun and educational multiple-choice quiz questions about ${qrData}. 
            Each question should have four answer options, with one correct answer marked clearly. And make sure the questions is for the kids who born in ${birthDate}`,
          },
        ],
        stream: false,
      };
  
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${API_KEY}`,
      };
  
      const res = await axios.post(url, requestData, { headers });
      const quizMessage = res.data.choices[0].message.content;
  
      console.log(quizMessage)
      setQuizResponse(formatText(quizMessage));

      setQuizLoaded(true);
      
    } catch (error) {
      console.error("OpenAI API error:", error);
      setQuizResponse("Failed to fetch a quiz. Please try again.");
    } finally {
      setQuizLoading(false);
    }
  };

  const parseQuizResponse = (quizText) => {
    // Remove the first and last lines that contain introductory/conclusion text
    const lines = quizText
        .split("\n")
        .map(line => line.trim())
        .filter(line => line && !line.startsWith("Sure!") && !line.startsWith("Hope"));

    const questions = [];
    let currentQuestion = null;

    lines.forEach((line) => {
        if (line.startsWith("### Question")) {
            // Start a new question block
            if (currentQuestion) questions.push(currentQuestion);

            currentQuestion = { question: "", options: [] };
            currentQuestion.question = line.replace(/### Question \d+:/, "").trim();
        } else if (/^[A-D]\)/.test(line)) {
            // Add answer options
            const isCorrect = line.includes("**Correct Answer:**");
            const cleanOption = line.replace("**Correct Answer:**", "").trim();
            currentQuestion.options.push({ text: cleanOption, isCorrect });
        } else if (line.startsWith("**Correct Answer:")) {
            // Extract the correct answer
            const correctOption = line.match(/[A-D]\)/)?.[0]; // Extract letter (A, B, C, or D)
            if (correctOption && currentQuestion) {
                currentQuestion.options.forEach(opt => {
                    if (opt.text.startsWith(correctOption)) {
                        opt.isCorrect = true;
                    }
                });
            }
        } else if (currentQuestion && !currentQuestion.question) {
            // Assign the main question text (first non-empty line after "### Question X")
            currentQuestion.question = line;
        }
    });

    // Push the last parsed question
    if (currentQuestion) questions.push(currentQuestion);

    return questions;
};



  useEffect(() => {
    if (quizResponse) {
      setParsedQuiz(parseQuizResponse(quizResponse));
    }
  }, [quizResponse]);

  // Handle answer selection
  const handleAnswerClick = (questionIndex, optionIndex, isCorrect) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionIndex]: { optionIndex, isCorrect },
    }));
  };
  

  return (
    <div className="container mt-4">
      <h2 className="text-center">API Response using chatgpt 4o mini</h2>
      {loading ? (
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <div className="alert alert-info mt-3" dangerouslySetInnerHTML={{ __html: response }}></div>
      )}

      {/* Quiz Me Button */}
      {!quizLoaded && (
  <button
    className="btn btn-primary w-100 mt-3 mb-4"
    onClick={fetchQuiz}
    disabled={quizLoading}
  >
    {quizLoading ? "Generating Quiz..." : "Quiz Me"}
  </button>
)}


      {/* Display Quiz Response */}
      {parsedQuiz.length > 0 ? (
        parsedQuiz.map((quiz, qIndex) => (
          <div key={qIndex} className="mb-4 p-3 border rounded shadow bg-white">
            <h5 className="mb-3">{quiz.question}</h5>
            <div className="d-flex flex-column">
              {quiz.options.map((option, oIndex) => {
                const selected = selectedAnswers[qIndex];
                const isSelected = selected && selected.optionIndex === oIndex;
                const isCorrect = selected && selected.isCorrect;
                const btnClass = isSelected
                  ? isCorrect
                    ? "btn-success"
                    : "btn-danger"
                  : "btn-outline-primary";

                return (
                  <button
                    key={oIndex}
                    className={`btn ${btnClass} mb-2`}
                    onClick={() => handleAnswerClick(qIndex, oIndex, option.isCorrect)}
                    disabled={!!selected} // Disable buttons after selecting an answer
                  >
                    {option.text}
                  </button>
                );
              })}
            </div>
          </div>
        ))
      ) : (
        <p className="alert alert-warning">No quiz available.</p>
      )}

      <button className="btn btn-secondary w-100 mt-3 mb-4" onClick={() => navigate("/")}>
        Scan Again
      </button>
    </div>
  );
};

export default ResultPage;
